// STORE DEPENDANCY
import { Action } from '@ngrx/store';

// COMMON INTERFACES
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';

export enum ActionTypes {
  // Request ACTIONS
  REQUEST_COMMON = '[Request] Request Common',
  REQUEST_COMMON_SUCCESS = '[Request] Request Common Success',
}

// -------------------------------
//  Request Common
// -------------------------------
export class RequestCommonAction implements Action {
  readonly type = ActionTypes.REQUEST_COMMON;
  constructor(public payload: ApiPayload) { }
}

// -------------------------------
//  Request Common Success
// -------------------------------
export class RequestCommonSuccessAction implements Action {
  readonly type = ActionTypes.REQUEST_COMMON_SUCCESS;
  constructor(public response?: any) { }
}


export type Actions =
  | RequestCommonAction
  | RequestCommonSuccessAction;

